/* Tuopin mobile sticky cart: body-level dock for mobile visual viewports. */
(function() {
  'use strict';

  var STYLE_ID = 'tuopin-mobile-sticky-cart';
  var DOCK_ATTRIBUTE = 'data-tuopin-mobile-dock';
  var VISIBLE_ATTRIBUTE = 'data-tuopin-dock-visible';
  var SUPPRESS_ATTRIBUTE = 'data-tuopin-dock-suppressed';

  function installStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = [
      '@media screen and (max-width: 999px) {',
      '  body > product-sticky-form.product-sticky-form[data-tuopin-mobile-dock] {',
      '    position: fixed !important;',
      '    inset-inline: 0 !important;',
      '    bottom: 0 !important;',
      '    z-index: 40 !important;',
      '    display: block !important;',
      '    width: 100% !important;',
      '    max-width: none !important;',
      '    margin: 0 !important;',
      '    padding: 0 !important;',
      '    background: #fff !important;',
      '    border-top: 1px solid rgba(18, 18, 18, .18);',
      '    box-shadow: none !important;',
      '    opacity: 1;',
      '    visibility: visible;',
      '    transform: translate3d(0, 0, 0);',
      '    transition: transform 180ms cubic-bezier(.2, .8, .2, 1), opacity 150ms ease, visibility 150ms ease;',
      '    -webkit-backface-visibility: hidden;',
      '    backface-visibility: hidden;',
      '  }',
      '  body > product-sticky-form.product-sticky-form[data-tuopin-mobile-dock]:not([data-tuopin-dock-visible]),',
      '  body > product-sticky-form.product-sticky-form[data-tuopin-mobile-dock][data-tuopin-dock-suppressed] {',
      '    display: block !important;',
      '    opacity: 0 !important;',
      '    visibility: hidden !important;',
      '    transform: translate3d(0, 100%, 0) !important;',
      '    pointer-events: none !important;',
      '  }',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .product-sticky-form__inner {',
      '    box-sizing: border-box;',
      '    display: block !important;',
      '    width: 100% !important;',
      '    max-width: none !important;',
      '    margin: 0 !important;',
      '    padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px)) !important;',
      '  }',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .product-sticky-form__form,',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .product-sticky-form__payment-container {',
      '    display: block !important;',
      '    width: 100% !important;',
      '    min-width: 0 !important;',
      '    margin: 0 !important;',
      '  }',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .tuopin-sticky-atc {',
      '    box-sizing: border-box;',
      '    display: flex !important;',
      '    align-items: center;',
      '    justify-content: center;',
      '    width: 100% !important;',
      '    min-height: 56px !important;',
      '    height: 56px !important;',
      '    margin: 0 !important;',
      '    padding: 0 18px !important;',
      '    border: 1px solid #111 !important;',
      '    border-radius: 0 !important;',
      '    background: #111 !important;',
      '    color: #fff !important;',
      '    box-shadow: none !important;',
      '    font-size: 14px;',
      '    font-weight: 600;',
      '    line-height: 1.2;',
      '    letter-spacing: 0;',
      '    text-transform: uppercase;',
      '    white-space: nowrap;',
      '    touch-action: manipulation;',
      '    -webkit-tap-highlight-color: transparent;',
      '    transition: background-color 140ms ease, color 140ms ease, opacity 140ms ease, transform 80ms ease;',
      '  }',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .tuopin-sticky-atc:active:not([disabled]) {',
      '    transform: scale(.997);',
      '  }',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .tuopin-sticky-atc[disabled] {',
      '    background: #777 !important;',
      '    border-color: #777 !important;',
      '    color: #fff !important;',
      '    opacity: 1;',
      '  }',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .tuopin-sticky-atc > .loader-button__text {',
      '    display: flex;',
      '    align-items: center;',
      '    justify-content: center;',
      '    gap: 8px;',
      '  }',
      '  @supports (padding-left: max(0px)) {',
      '    body > product-sticky-form[data-tuopin-mobile-dock] .product-sticky-form__inner {',
      '      padding-left: max(12px, env(safe-area-inset-left, 0px)) !important;',
      '      padding-right: max(12px, env(safe-area-inset-right, 0px)) !important;',
      '      padding-bottom: max(8px, env(safe-area-inset-bottom, 0px)) !important;',
      '    }',
      '  }',
      '}',
      '@media screen and (min-width: 1000px) {',
      '  body > product-sticky-form.product-sticky-form[data-tuopin-mobile-dock] {',
      '    display: none !important;',
      '    visibility: hidden !important;',
      '    pointer-events: none !important;',
      '  }',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  body > product-sticky-form.product-sticky-form[data-tuopin-mobile-dock],',
      '  body > product-sticky-form[data-tuopin-mobile-dock] .tuopin-sticky-atc {',
      '    transition: none !important;',
      '  }',
      '}'
    ].join('\n');

    document.head.appendChild(style);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    var value = Number(number);
    if (!Number.isFinite(value)) return '';

    var fixed = (value / 100).toFixed(precision);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var themeFormat = window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.moneyFormat;
    var template = format || themeFormat || ('$' + '{{amount}}');
    var match = template.match(/{{\s*(amount(?:_no_decimals|_with_comma_separator|_no_decimals_with_comma_separator)?)\s*}}/);
    if (!match) return formatWithDelimiters(cents, 2, ',', '.');

    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return template.replace(match[0], value).replace(/<[^>]*>/g, '').trim();
  }

  function formExists(sticky) {
    var formId = sticky.getAttribute('form-id');
    return Boolean(formId && document.getElementById(formId));
  }

  function stickyForms(formId) {
    return Array.prototype.filter.call(
      document.querySelectorAll('product-sticky-form.product-sticky-form'),
      function(sticky) {
        return formExists(sticky) && (!formId || sticky.getAttribute('form-id') === formId);
      }
    );
  }

  function renderButton(sticky, variant) {
    var button = sticky.querySelector('#StickyAddToCart');
    if (!button) return;

    var hasVariant = variant !== null;
    var available = variant === undefined
      ? button.dataset.currentAvailable === 'true'
      : Boolean(variant && variant.available);
    var cents = variant && variant.price !== undefined
      ? variant.price
      : button.dataset.currentPrice;

    if (variant !== undefined) {
      button.dataset.currentAvailable = String(available);
      if (variant && variant.price !== undefined) {
        button.dataset.currentPrice = String(variant.price);
      }
    }

    var label = hasVariant
      ? (available ? button.dataset.availableLabel : button.dataset.soldOutLabel)
      : button.dataset.unavailableLabel;

    var form = document.getElementById(sticky.getAttribute('form-id'));
    var busy = Boolean(form && form.hasAttribute('data-tuopin-form-busy'));
    var disabled = busy || !available || Boolean(form && form._tuopinUnavailable);
    button.disabled = disabled;
    button.setAttribute('aria-disabled', String(disabled));
    if (busy) return;

    var content = button.querySelector(':scope > .loader-button__text') || button;
    content.textContent = '';

    var labelNode = document.createElement('span');
    labelNode.className = 'tuopin-sticky-atc__label';
    labelNode.textContent = label;
    content.appendChild(labelNode);

    if (available && cents !== undefined && cents !== '') {
      var separator = document.createElement('span');
      separator.className = 'tuopin-sticky-atc__separator';
      separator.setAttribute('aria-hidden', 'true');
      separator.textContent = '\u2014';
      content.appendChild(separator);

      var price = document.createElement('span');
      price.className = 'tuopin-sticky-atc__price';
      price.textContent = formatMoney(cents, sticky.dataset.moneyFormat);
      content.appendChild(price);
    }
  }

  function syncDrawerState(sticky) {
    var cartDrawer = document.getElementById('mini-cart');
    var suppressed = Boolean(cartDrawer && cartDrawer.hasAttribute('open'));

    sticky.toggleAttribute(SUPPRESS_ATTRIBUTE, suppressed);

    if (suppressed || window.innerWidth > 999 || !sticky.hasAttribute(VISIBLE_ATTRIBUTE)) {
      document.documentElement.style.removeProperty('--cart-notification-offset');
    } else {
      document.documentElement.style.setProperty('--cart-notification-offset', sticky.clientHeight + 'px');
    }
  }

  var visibilityResizeObserver;
  var observedVisibilityTargets = [];

  function visibilityTargets(sticky) {
    var formId = sticky.getAttribute('form-id');
    var media = Array.prototype.find.call(document.querySelectorAll('product-media[form-id]'), function(element) {
      return element.getAttribute('form-id') === formId;
    });
    return [
      document.querySelector('.shopify-section--header store-header'),
      media && media.querySelector('.product__media-list'),
      media && media.closest('.shopify-section--main-product')
    ];
  }

  function observeVisibilityTargets(targets) {
    if (!window.ResizeObserver) return;
    var elements = targets.filter(Boolean);
    if (elements.length === observedVisibilityTargets.length && elements.every(function(element, index) {
      return element === observedVisibilityTargets[index];
    })) return;

    if (!visibilityResizeObserver) visibilityResizeObserver = new window.ResizeObserver(scheduleViewportSync);
    visibilityResizeObserver.disconnect();
    observedVisibilityTargets = elements;
    elements.forEach(function(element) { visibilityResizeObserver.observe(element); });
  }

  function syncHeaderMediaVisibility(sticky) {
    var viewportWidth = window.innerWidth;
    if (viewportWidth > 999) return;

    var targets = visibilityTargets(sticky);
    var headerRect = targets[0] && targets[0].getBoundingClientRect();
    var mediaRect = targets[1] && targets[1].getBoundingClientRect();
    var hasPassedTrigger = Boolean(headerRect && mediaRect &&
      headerRect.width > 0 && headerRect.height > 0 && headerRect.bottom > 0 &&
      mediaRect.width > 0 && mediaRect.height > 0 && mediaRect.top < headerRect.bottom);
    sticky.toggleAttribute(VISIBLE_ATTRIBUTE, hasPassedTrigger);
    sticky.toggleAttribute('hidden', !hasPassedTrigger);
  }

  function mountDock() {
    installStyles();

    var forms = Array.prototype.slice.call(
      document.querySelectorAll('product-sticky-form.product-sticky-form')
    );
    var active = forms.find(function(sticky) {
      return sticky.closest('#main') && formExists(sticky);
    }) || forms.find(formExists);

    if (!active) {
      observeVisibilityTargets([]);
      forms.filter(function(sticky) { return sticky.hasAttribute(DOCK_ATTRIBUTE); }).forEach(function(sticky) {
        sticky.removeAttribute(VISIBLE_ATTRIBUTE);
        sticky.setAttribute('hidden', '');
        syncDrawerState(sticky);
      });
      return;
    }

    forms.forEach(function(sticky) {
      if (sticky !== active && sticky.hasAttribute(DOCK_ATTRIBUTE)) {
        sticky.remove();
      }
    });

    active.setAttribute(DOCK_ATTRIBUTE, '');
    if (active.parentElement !== document.body) {
      document.body.appendChild(active);
    }

    // This body-level dock uses the header/media boundary, not the original payment-area observer.
    if (active.intersectionObserver) active.intersectionObserver.disconnect();
    observeVisibilityTargets(visibilityTargets(active));
    renderButton(active, undefined);
    syncHeaderMediaVisibility(active);
    syncDrawerState(active);
  }

  function syncSticky(event) {
    var detail = event && event.detail ? event.detail : {};
    var variant = Object.prototype.hasOwnProperty.call(detail, 'variant')
      ? detail.variant
      : undefined;

    stickyForms(detail.formId).forEach(function(sticky) {
      renderButton(sticky, variant);
    });
  }

  var pendingVariantSyncs = new WeakMap();

  function scheduleSync(event) {
    var detail = event && event.detail ? event.detail : {};
    var variant = Object.prototype.hasOwnProperty.call(detail, 'variant') ? detail.variant : undefined;
    var forms = detail.formId
      ? [document.getElementById(detail.formId)]
      : stickyForms().map(function(sticky) { return document.getElementById(sticky.getAttribute('form-id')); });

    forms.forEach(function(form) {
      if (!form) return;
      var previous = pendingVariantSyncs.get(form);
      if (previous) {
        window.cancelAnimationFrame(previous.frame);
        window.clearTimeout(previous.timer);
      }

      var formId = form.getAttribute('id');
      var job = { frame: null, timer: null };
      pendingVariantSyncs.set(form, job);

      function isCurrent() {
        // A replacement product may reuse the ID, but must not receive the old variant.
        return pendingVariantSyncs.get(form) === job && document.getElementById(formId) === form;
      }

      function refresh() {
        if (!isCurrent()) return;
        mountDock();
        stickyForms(formId).forEach(function(sticky) { renderButton(sticky, variant); });
      }

      job.frame = window.requestAnimationFrame(function() {
        job.frame = null;
        if (!isCurrent()) return;
        refresh();
        job.timer = window.setTimeout(function() {
          job.timer = null;
          refresh();
          if (pendingVariantSyncs.get(form) === job) pendingVariantSyncs.delete(form);
        }, 120);
      });
    });
  }

  function scheduleMount() {
    window.requestAnimationFrame(function() {
      mountDock();
      window.setTimeout(mountDock, 120);
    });
  }

  var viewportSyncScheduled = false;

  function scheduleViewportSync() {
    if (viewportSyncScheduled) return;
    viewportSyncScheduled = true;

    window.requestAnimationFrame(function() {
      viewportSyncScheduled = false;

      var sticky = document.querySelector('body > product-sticky-form.product-sticky-form[data-tuopin-mobile-dock]');
      if (!sticky) return;

      syncHeaderMediaVisibility(sticky);
      syncDrawerState(sticky);
    });
  }

  window.TuopinMobileStickyCart = {
    refresh: scheduleMount
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountDock, { once: true });
  } else {
    mountDock();
  }

  document.addEventListener('variant:change', scheduleSync);
  document.addEventListener('variant:changed', scheduleSync);
  document.addEventListener('tuopin:form-busy', syncSticky);
  document.addEventListener('shopify:section:load', scheduleMount);
  document.addEventListener('shopify:section:unload', scheduleMount);
  document.addEventListener('tuopin:product:swapped', scheduleMount);
  document.addEventListener('openable-element:open', scheduleMount);
  document.addEventListener('openable-element:close', scheduleMount);
  window.addEventListener('scroll', scheduleViewportSync, { passive: true });
  window.addEventListener('resize', scheduleViewportSync);
  window.addEventListener('pageshow', scheduleMount);
  window.addEventListener('load', scheduleMount, { once: true });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleViewportSync);
  }
})();
